import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import ClassroomDetails from './components/SessionContentDetails';
import SessionProp from '../propTypes/sessionProp';
import { compose } from '../../../services/utilityFunctions';
import MoreInfoClassroom from './components/MoreInfoClassroom';
import { checkIfUserIsInParticipantsList, checkIfHasCreatorAccess } from '../propTypes/sessionUtils';
import LoggedUserContext from '../../../contextProviders/LoggedUserContext';

const ClassroomContent = props => {
  /** Context */
  const { loggedUser } = useContext(LoggedUserContext);
  const loggedUserId = loggedUser?._id || null;
  /** PROPS */
  const {
    session,
    onQRModal,
  } = props;

  // If user already subscribed or has creator access
  const hasAccessToContent =
    checkIfUserIsInParticipantsList(session, loggedUserId) ||
    checkIfHasCreatorAccess(session, loggedUserId);

  return (
    <>
      {hasAccessToContent && (
        <div className="session-content-active">
          <ClassroomDetails session={session} />
          <MoreInfoClassroom session={session} onQRModal={onQRModal} />
        </div>
      )}
    </>
  );
};

ClassroomContent.propTypes = {
  session: PropTypes.shape(SessionProp.propType).isRequired,
  onQRModal: PropTypes.func.isRequired,
};
ClassroomContent.defaultProps = {};

export default compose(
  translate,
)(ClassroomContent);
